import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-y-2 border-coral/30 bg-carbon-soft" data-id="element-25" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-7" data-id="element-26" data-mp="vqtcaxxz9rzd">
        <Reveal className="text-center" data-id="element-27" data-mp="qt07a88ev40o">
          <h2 id="bonos" className="font-display text-2xl uppercase leading-none tracking-wide text-coral sm:text-4xl" data-id="element-28" data-mp="qw5vzmd4o3vv">
            5 Bonos incluidos
          </h2>
          <p className="mt-1 text-[0.82rem] font-bold text-cream sm:text-base" data-id="element-29" data-mp="zsn8ou1549tq">
            Y además recibes 5 recursos prácticos — GRATIS con tu compra.
          </p>
        </Reveal>

        <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-30" data-mp="19mdwdwpg0g8d">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-gold/50 bg-carbon p-3.5" data-id="element-31" data-mp="1nhpso8j8yere" data-mpi={i}>
              <span className="self-start rounded bg-gold/15 px-2 py-0.5 text-[0.66rem] font-extrabold uppercase tracking-wide text-gold sm:text-xs" data-id="element-32" data-mp="3trnhldvnrc7q">
                {bono.label}
              </span>
              <h3 className="mt-1.5 font-display text-[0.98rem] uppercase leading-tight tracking-wide text-cream sm:text-base" data-id="element-33" data-mp="7kfkszyt0dnb">
                {bono.title}
              </h3>
              <p className="mt-1 text-[0.78rem] leading-snug text-beige sm:text-[0.82rem]" data-id="element-34" data-mp="chz7mo9khyqv">
                {bono.desc}
              </p>
              <p className="mt-auto pt-2 text-[0.75rem] font-bold text-muted line-through sm:text-sm" data-id="element-35" data-mp="lbu1v195i4rq">
                Valor: {bono.value}
              </p>
            </Reveal>)}

          <Reveal as="li" delay={0.16} className="flex h-full flex-col items-center justify-center rounded-xl border-2 border-gold bg-gold/10 p-3.5 text-center" data-id="element-36" data-mp="vatcuqhe2chw">
            <p className="font-display text-base uppercase leading-tight tracking-wide text-cream sm:text-lg" data-id="element-37" data-mp="akfq0p7pym9d">
              💰 Valor total de los 5 bonos:
            </p>
            <p className="font-display text-4xl leading-none text-cream line-through decoration-danger decoration-2 sm:text-5xl" data-id="element-38" data-mp="kb1z00kxkej3">
              {BONUS_VALUE}
            </p>
            <p className="mt-1 font-display text-lg uppercase leading-tight tracking-wide text-gold sm:text-2xl" data-id="element-39" data-mp="fi8tvbljv46h">
              🔥 Hoy los 5 están incluidos gratis.
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}